/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import Tooltip from '@omilia/tooltip';
import { Row, Col } from 'react-flexbox-grid';

import _get from 'lodash/get';
import _find from 'lodash/find';

import TrashTooltip from 'components/TrashTooltip';
import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import Toggler from 'components/Toggler';

import {
  FormGroupSelect,
  FormGroupField,
  FormGroupTags,
} from 'components/Form';

import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';
import { featureTypesType, entityType } from 'types';

import './style.scss';

import { CONDITION_TYPE, CONDITION_TYPE_MAP } from '../../constants';

const ENTITY_OPERATORS = [
  { value: 'partof', label: 'PART OF' },
  { value: 'partofneq', label: 'PART OF NEQ (Not Equal)' },
  { value: 'contains', label: 'CONTAINS' },
];

const ROW_COLOR = {
  [CONDITION_TYPE.ENTITY]: '#7470cc',
  [CONDITION_TYPE.REGEXP]: '#f38e0d',
  [CONDITION_TYPE.FEATURE]: '#20d6c1',
};

/* eslint-disable camelcase */
const validationRegex = {
  Actor: /customer|company|system|other|undefined/,
  Aspect: /perfective|imperfective/,
  GrammarNumber: /singular|plural/,
  Boolean: /true|false/,
  Integer: /^[0-9]+$/,
  Mood: /volition|negation|undefined/,
  PartOfSpeech: /noun|pronoun|verb|adjective|adverb|preposition|conjunction|article/,
  String: /.*/,
  Possessor: /customer|company|system|other|undefined/,
  Tense: /past|present|future|undefined/,
};

export default class Conditions extends Component {
  static propTypes = {
    change: PropTypes.func.isRequired,
    innerRef: PropTypes.func.isRequired,
    isArchived: PropTypes.bool.isRequired,
    onScrollBottom: PropTypes.func.isRequired,
    onSearchEntity: PropTypes.func.isRequired,
    allEntities: PropTypes.arrayOf(entityType),
    allFeatures: PropTypes.arrayOf(featureTypesType),
    filteredMatchingPatterns: PropTypes.arrayOf(entityType),
    isLoading: PropTypes.bool,
    matchingPatterns: PropTypes.arrayOf(entityType),
  };

  createDeleteEntityHandler = (fields, index) => () => {
    fields.remove(index);
  };

  createAddEntityHandler = fields => () => {
    fields.push({
      condition_type: CONDITION_TYPE.ENTITY,
      entity_condition: {
        entity: null,
        matching_pattern_element: null,
      },
    });

    this.props.onScrollBottom();
  };

  createAddFeatureHandler = fields => () => {
    fields.push({
      condition_type: CONDITION_TYPE.FEATURE,
      entity_feature_condition: {
        matching_pattern_element: null,
        entity_feature: null,
        operator: 'eq',
        values: [],
      },
    });

    this.props.onScrollBottom();
  };

  createAddRegexHandler = fields => () => {
    fields.push({
      condition_type: CONDITION_TYPE.REGEXP,
      regexp_condition: {
        matching_pattern_element: null,
        regexp: null,
      },
    });

    this.props.onScrollBottom();
  };

  createChangeEntityEntityHandler = (fields, index) => () => {
    const {
      entity_condition: { matching_pattern_element },
    } = fields.get(index);

    if (!matching_pattern_element) {
      return;
    }

    fields.splice(index, 1, {
      condition_type: CONDITION_TYPE.ENTITY,
      entity_condition: {
        matching_pattern_element,
        entity: null,
      },
    });
  };

  createChangeFeatureEntityHandler = (fields, index) => () => {
    const {
      entity_feature_condition: { matching_pattern_element },
    } = fields.get(index);

    if (!matching_pattern_element) {
      return;
    }

    fields.splice(index, 1, {
      condition_type: CONDITION_TYPE.FEATURE,
      entity_feature_condition: {
        matching_pattern_element,
        entity_feature: null,
        operator: 'eq',
        values: [],
      },
    });
  };

  createChangeRegexpEntityHandler = (fields, index) => () => {
    const {
      regexp_condition: { matching_pattern_element },
    } = fields.get(index);

    if (!matching_pattern_element) {
      return;
    }

    fields.splice(index, 1, {
      condition_type: CONDITION_TYPE.REGEXP,
      regexp_condition: {
        matching_pattern_element,
        regexp: null,
      },
    });
  };

  handleChangeValues = (values, field) => {
    this.props.change(`${field}.entity_feature_condition.values`, values);
  };

  /* eslint-disable jsx-a11y/label-has-for */
  renderInvertField = ({ input: { name, value, ...input } }) => (
    <div styleName="invert">
      <input
        checked={value}
        disabled={this.props.isArchived}
        id={name}
        styleName="input"
        type="checkbox"
        {...input}
      />
      <Tooltip content="Negate this condition" placement="right">
        <label data-test="negate-label" htmlFor={name} />
      </Tooltip>
    </div>
  );

  renderEntityGroup = (field, fields, index) => {
    const {
      isArchived,
      isLoading,
      allEntities,
      matchingPatterns,
      onSearchEntity,
    } = this.props;

    const {
      entity_condition: { matching_pattern_element },
    } = fields.get(index);
    const isEntityArchived = _get(matching_pattern_element, 'archived', false);
    const isDisabled = isArchived || isEntityArchived;

    return [
      <Col key={0} xs={3}>
        <Field
          itemWithIndex
          component={FormGroupAutoCompleteField}
          data-test="entity-entity-field"
          isArchived={isEntityArchived}
          isDisabled={isArchived}
          items={matchingPatterns}
          name={`${field}.entity_condition.matching_pattern_element`}
          placeholder="Select Entity"
          onChange={this.createChangeEntityEntityHandler(fields, index)}
        />
      </Col>,
      <Col key={1} xs={3}>
        <Field
          placeholderSelectable
          component={FormGroupSelect}
          data-test="operator-field"
          disabled={isDisabled}
          name={`${field}.entity_condition.operator`}
          options={ENTITY_OPERATORS}
          placeholder="Select Operator"
        />
      </Col>,
      <Col key={2} xs={3}>
        <Field
          component={FormGroupAutoCompleteField}
          isDisabled={isDisabled}
          isLoading={isLoading}
          items={allEntities}
          name={`${field}.entity_condition.entity`}
          placeholder="Select Entity"
          onChangeValue={term => onSearchEntity(term, false)}
          onOpen={() => onSearchEntity('', false)}
        />
      </Col>,
    ];
  };

  renderFeatureGroup = (field, fields, index) => {
    const { filteredMatchingPatterns, isArchived } = this.props;
    const {
      entity_feature_condition,
      entity_feature_condition: { matching_pattern_element },
    } = fields.get(index);
    const isEntityArchived = _get(matching_pattern_element, 'archived', false);

    const isDisabled = isArchived || isEntityArchived;

    // Feature Type
    const type = _get(
      entity_feature_condition,
      'entity_feature.feature_type',
      null,
    );

    // Matching Pattern Features
    const features = _get(
      entity_feature_condition,
      'matching_pattern_element.features',
      [],
    );

    const feature = _find(this.props.allFeatures, {
      name: type,
    });

    const getSuggestions = inputValue => {
      let suggestedValues = [];

      if (feature.available_values) {
        suggestedValues = feature.available_values.map(value =>
          value.toString(),
        );
      }

      return suggestedValues.filter(
        state => state.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
      );
    };

    return [
      <Col key={0} xs={3}>
        <Field
          itemWithIndex
          component={FormGroupAutoCompleteField}
          data-test="entity-feature-field"
          isArchived={isEntityArchived}
          isDisabled={isArchived}
          items={filteredMatchingPatterns}
          name={`${field}.entity_feature_condition.matching_pattern_element`}
          placeholder="Select Entity"
          onChange={this.createChangeFeatureEntityHandler(fields, index)}
        />
      </Col>,

      <Col key={1} xs={2}>
        <Field
          component={FormGroupAutoCompleteField}
          isDisabled={isDisabled}
          items={features}
          name={`${field}.entity_feature_condition.entity_feature`}
          placeholder="Select Feature"
        />
      </Col>,

      type && (
        <Col key={2} xs={3}>
          <Row>
            <Col xs={4}>
              <div styleName="property-name">Equals</div>
            </Col>

            <Col xs={8}>
              <Field
                component={FormGroupTags}
                data-test="condition-feature-value"
                getSuggestions={getSuggestions}
                isDisabled={isDisabled}
                name={`${field}.entity_feature_condition.values`}
                placeholder="Enter text"
                styleName="tags-field"
                validationRegex={validationRegex[type]}
                onChangeValues={values =>
                  this.handleChangeValues(values, field)
                }
              />
            </Col>
          </Row>
        </Col>
      ),
    ];
  };

  renderRegexpGroup = (field, fields, index) => {
    const { matchingPatterns, isArchived } = this.props;
    const {
      regexp_condition: { matching_pattern_element },
    } = fields.get(index);
    const isEntityArchived = _get(matching_pattern_element, 'archived', false);
    const isDisabled = isArchived || isEntityArchived;

    return [
      <Col key={0} xs={4}>
        <Field
          itemWithIndex
          component={FormGroupAutoCompleteField}
          data-test="entity-regex-field"
          isArchived={isEntityArchived}
          isDisabled={isArchived}
          items={matchingPatterns}
          name={`${field}.regexp_condition.matching_pattern_element`}
          placeholder="Select Entity"
          onChange={this.createChangeRegexpEntityHandler(fields, index)}
        />
      </Col>,
      <Col key={1} xs={4}>
        <Field
          component={FormGroupField}
          data-test="regex-text-field"
          disabled={isDisabled}
          name={`${field}.regexp_condition.regexp`}
          placeholder="Type a regular expression"
          type="text"
        />
      </Col>,
    ];
  };

  /* eslint-disable camelcase */
  renderGroup = (fields, field, index) => {
    const fieldPayload = fields.get(index);
    const { condition_type } = fieldPayload;

    return (
      <Row
        data-test="condition-group"
        style={{
          boxShadow: `inset 3px 0 ${ROW_COLOR[condition_type]}`,
        }}
        styleName="group"
        top="xs"
      >
        {condition_type === CONDITION_TYPE.ENTITY &&
          this.renderEntityGroup(field, fields, index)}

        {condition_type === CONDITION_TYPE.FEATURE &&
          this.renderFeatureGroup(field, fields, index)}

        {condition_type === CONDITION_TYPE.REGEXP &&
          this.renderRegexpGroup(field, fields, index)}

        <Col xs={2}>
          <Field
            component={Toggler}
            data-test="negate-label"
            disabled={this.props.isArchived}
            label="Negate"
            name={`${field}.negate`}
            styleName="toggler-field"
          />
        </Col>
        {!this.props.isArchived && CONDITION_TYPE_MAP[condition_type] && (
          <Col xs>
            <Row end="xs">
              <TrashTooltip
                data-test="delete-condition"
                styleName="trash"
                text={`Delete ${CONDITION_TYPE_MAP[
                  condition_type
                ].toLowerCase()} condition`}
                onDelete={this.createDeleteEntityHandler(fields, index)}
              />
            </Row>
          </Col>
        )}
      </Row>
    );
  };

  renderList = ({ fields }) => (
    <div styleName="root">
      <InspectHeader>
        {!this.props.isArchived && (
          <div styleName="header-buttons">
            <InspectButton
              isHeader
              data-test="condition-add-entity"
              onClick={this.createAddEntityHandler(fields)}
            >
              + Entity Condition
            </InspectButton>

            <InspectButton
              isHeader
              data-test="condition-add-feature"
              onClick={this.createAddFeatureHandler(fields)}
            >
              + Feature Condition
            </InspectButton>

            <InspectButton
              isHeader
              data-test="condition-add-regex"
              onClick={this.createAddRegexHandler(fields)}
            >
              + RegEx Condition
            </InspectButton>
          </div>
        )}
      </InspectHeader>

      <div
        ref={this.props.innerRef}
        data-test="conditions-list"
        styleName="inner"
      >
        {fields.map((field, index) => (
          <div key={field}>{this.renderGroup(fields, field, index)}</div>
        ))}
      </div>
    </div>
  );

  render() {
    return <FieldArray component={this.renderList} name="conditions" />;
  }
}
